import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AdminAuthCtx = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshAdmin = useCallback(async () => {
    const token = localStorage.getItem("falzilla_admin_token");
    if (!token) { setAdmin(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/admin/me", { headers: { Authorization: `Bearer ${token}` } });
      setAdmin(data);
    } catch {
      localStorage.removeItem("falzilla_admin_token");
      setAdmin(null);
    }
    setLoading(false);
  }, []);

  useEffect(() => { refreshAdmin(); }, [refreshAdmin]);

  const devLogin = async (email, password) => {
    const { data } = await api.post("/admin/auth/dev-login", { email, password });
    localStorage.setItem("falzilla_admin_token", data.session_token);
    setAdmin(data.admin);
    return data.admin;
  };

  const oauthLogin = async (session_id) => {
    const { data } = await api.post("/admin/auth/session", { session_id });
    localStorage.setItem("falzilla_admin_token", data.session_token);
    setAdmin(data.admin);
    return data.admin;
  };

  const adminGoogleLogin = async (credential) => {
    const { data } = await api.post("/admin/auth/google", { credential });
    localStorage.setItem("falzilla_admin_token", data.session_token);
    setAdmin(data.admin);
    return data.admin;
  };

  const logout = async () => {
    try {
      const token = localStorage.getItem("falzilla_admin_token");
      await api.post("/admin/logout", {}, { headers: { Authorization: `Bearer ${token}` } });
    } catch {}
    localStorage.removeItem("falzilla_admin_token");
    setAdmin(null);
  };

  return (
    <AdminAuthCtx.Provider value={{ admin, loading, devLogin, oauthLogin, adminGoogleLogin, logout, refreshAdmin }}>
      {children}
    </AdminAuthCtx.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthCtx);

export const adminApi = (config = {}) => {
  const token = localStorage.getItem("falzilla_admin_token");
  return { ...config, headers: { ...(config.headers || {}), Authorization: `Bearer ${token}` } };
};
